import { merge } from 'lodash-es';

import {
  gridDefaultProps,
  sparklineDefaultProps,
  trendDefaultProps,
} from '../defaults.js';
import {
  PartialSingleValueGridConfig,
  SingleValueGridConfig,
} from '../types/single-value-grid.js';

/**
 * Builds the configuration by merging all the different sources of configuration in a cascade manner,
 * starting from the defaults, then considering the general props, and finally incorporating the props
 * accessed via accessors.
 *
 * @param propsConfig - The configuration provided through general props.
 * @param accessorsConfig - The configuration accessed via accessors.
 */
export function buildConfig(
  propsConfig: PartialSingleValueGridConfig,
  accessorsConfig: PartialSingleValueGridConfig = {},
): SingleValueGridConfig {
  const defaultProps: PartialSingleValueGridConfig = {
    ...gridDefaultProps,
  };

  if (propsConfig.sparkline || accessorsConfig.sparkline) {
    defaultProps.sparkline = sparklineDefaultProps;
  }

  if (propsConfig.trend || accessorsConfig.trend) {
    defaultProps.trend = trendDefaultProps;
  }

  return merge({}, defaultProps, propsConfig, accessorsConfig, {
    color: accessorsConfig.color ?? propsConfig.color,
  }) as SingleValueGridConfig;
}
